import type { AudioFeatureType } from '../api/cc-smarts/models/AudioFeature';
import type { AudioFeature } from '../types/audioFeature';

export const getFeatureInfo = (activeFeature: AudioFeatureType, featureList: AudioFeature[]) => {
	const feature = featureList.find((feature) => feature.name === activeFeature);
	return feature;
};
